import { render, staticRenderFns } from "./NavDrw.vue?vue&type=template&id=1354f1b2"
import script from "./NavDrw.vue?vue&type=script&lang=js"
export * from "./NavDrw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports